<div>
  {{ emptyMessage }}
</div>
